var React = require('react');

function IcResultComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-result"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M6.75 6.38672L9 4.13672L11.25 6.38672L13.5 4.13672L15.75 6.38672L18 4.13672L20.25 6.38672L22.5 4.13672L24.75 6.38672L27 4.13672L29.25 6.38672L31.05 4.58672V32.4139L29.25 30.6139L27 32.8639L24.75 30.6139L22.5 32.8639L20.25 30.6139L18 32.8639L15.75 30.6139L13.5 32.8639L11.25 30.6139L9 32.8639L6.75 30.6139L4.95 32.4139V4.58672L6.75 6.38672ZM7.05 7.40032V29.6003H28.95V7.40032H7.05ZM9.45 25.5503V23.4503H26.55V25.5503H9.45ZM9.45 19.5503V17.4503H26.55V19.5503H9.45ZM9.45 13.5503V11.4503H26.55V13.5503H9.45Z","fill":"#3E3E3E"})));
}

IcResultComponent.defaultProps = {"width":"36","height":"37","viewBox":"0 0 36 37","fill":"none"};

module.exports = IcResultComponent;

IcResultComponent.default = IcResultComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/EditDataModalV2/images/ic-result.component.svg
// module id = 700
// module chunks = 0